import { memo, useState } from 'react';
import { parseCards } from './cards/cardUtils';
import CardImg from './cards/CardImg';
import { roundBook, fmtBook } from '../../utils/casinoBook';
import Collapse from '../Collapse';
const REMARK_ICON = 'https://wver.sprintstaticdata.com/v230/static/front/img/icons/remark.png'

const CDN = 'https://wver.sprintstaticdata.com/v230/static/front/img';

function findBySid(sub, sid) {
  return sub.find((s) => s.sid === sid);
}

function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}

function suspCls(item) {
  return isSusp(item) ? ' suspended' : '';
}

function fmtAmt(n) {
  const x = Number(n) || 0;
  if (x >= 100000) return `${x / 100000}L`;
  if (x >= 1000) return `${x / 1000}K`;
  return String(x);
}

function bookOf(exposures, name, sid) {
  return roundBook(exposures?.[`sid:${sid}`] ?? exposures?.[name] ?? 0);
}

function bookCls(v) {
  return v < 0 ? 'book-red' : v > 0 ? 'book-green' : 'book-black';
}

// Player cards INTERLEAVED: first cards codes[0-5], second cards codes[6-11],
// Board codes[12-16] (excepted.txt-verified). Player N = codes[N-1], codes[N-1+6].
const PLAYERS = [
  { label: 'Player 1', sid: 11, cardIdx: [0, 6] },
  { label: 'Player 2', sid: 12, cardIdx: [1, 7] },
  { label: 'Player 3', sid: 13, cardIdx: [2, 8] },
  { label: 'Player 4', sid: 14, cardIdx: [3, 9] },
  { label: 'Player 5', sid: 15, cardIdx: [4, 10] },
  { label: 'Player 6', sid: 16, cardIdx: [5, 11] },
];

const PATTERNS = [
  { label: 'High Card',       sid: 21 },
  { label: 'Pair',            sid: 22 },
  { label: 'Two Pair',        sid: 23 },
  { label: 'Three of a Kind', sid: 24 },
  { label: 'Straight',        sid: 25 },
  { label: 'Flush',           sid: 26 },
  { label: 'Full House',      sid: 27 },
  { label: 'Four of a Kind',  sid: 28 },
  { label: 'Straight Flush',  sid: 29 },
];

const FULL_BOX_SIDS = new Set([27, 28, 29]);

// range collapse (info + icon-range)
function Range({ rangeId, min, max }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="float-right">
      <i
        data-toggle="collapse"
        data-target={`#${rangeId}`}
        aria-expanded={open ? 'true' : 'false'}
        className={`fas fa-info-circle${open ? '' : ' collapsed'}`}
        onClick={() => setOpen((o) => !o)}
      ></i>
      {' '}
      <Collapse id={rangeId} open={open} className="icon-range">
        {'\n                                R:'}
        <span>{fmtAmt(min)}</span>
        -
        <span>{fmtAmt(max)}</span>
      </Collapse>
    </div>
  );
}

const BetTablePoker6 = memo(function BetTablePoker6({ gameData, onBet, exposures }) {
  const [activeTab, setActiveTab] = useState('hands');
  const sub = gameData?.sub || [];
  const codes = parseCards(gameData?.card ?? '');
  const remark = gameData?.remark ?? '';
  const handleBet = onBet || (() => {});

  const cardSpan = (c, i) => (
    <span key={i} className="player-card">
      <span data-v-b64efdfa=""><CardImg data-v-b64efdfa="" code={c} /></span>
    </span>
  );

  // ── HANDS box ──
  const handsBox = (p, mobile) => {
    const item = findBySid(sub, p.sid);
    const book = bookOf(exposures, item?.nat, item?.sid);
    const cards = [codes[p.cardIdx[0]] || '1', codes[p.cardIdx[1]] || '1'];
    return (
      <div className="casino-col-container" key={p.sid}>
        <div className="casino-box-row">
          <div className="w-100 mb-1 pr">
            <b>{p.label}</b>
            {' '}
            <Range rangeId={`hands-${p.sid - 11}`} min={50} max={200000} />
          </div>
          <div
            className={`poker6box${suspCls(item)}`}
            onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}
          >
            <div className="casino-nation-name">
              <div>{cards.flatMap((c, i) => (i ? [' ', cardSpan(c, i)] : [cardSpan(c, i)]))}</div>
              {mobile ? (
                <span className="text-right mr-1 flex-odds">
                  <b className="d-block w-100">{item?.b ?? 0}</b>
                  {' '}
                  <span className={`w-100 ${bookCls(book)}`}>{fmtBook(book)}</span>
                </span>
              ) : (
                <span className="float-right mr-1">
                  <b className="d-block text-right">{item?.b ?? 0}</b>
                </span>
              )}
            </div>
          </div>
          {!mobile && <div className={`casino-book text-center w-100 ${bookCls(book)}`}>{fmtBook(book)}</div>}
        </div>
      </div>
    );
  };

  // ── PATTERN box ──
  const patternBox = (pt, mobile) => {
    const item = findBySid(sub, pt.sid);
    const book = bookOf(exposures, item?.nat, item?.sid);
    const fullbox = !mobile && FULL_BOX_SIDS.has(pt.sid) ? ' fullbox' : '';
    return (
      <div className={`casino-col-container${fullbox}`} key={pt.sid}>
        <div className="casino-box-row">
          <div className="w-100 mb-1 pr">
            <Range rangeId={`pattern-${pt.sid - 15}`} min={50} max={50000} />
          </div>
          <div
            className={`poker6box${suspCls(item)}`}
            onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}
          >
            <div className="casino-nation-name">
              {mobile ? (
                <>
                  <div><b>{pt.label}</b></div>
                  {' '}
                  <span className="text-right mr-1 flex-odds">
                    <b className="d-block w-100">{item?.b ?? 0}</b>
                    {' '}
                    <span className={`w-100 ${bookCls(book)}`}>{fmtBook(book)}</span>
                  </span>
                </>
              ) : (
                <>
                  <b>{pt.label}</b>
                  {' '}
                  <span className="d-block text-right"><b>{item?.b ?? 0}</b></span>
                </>
              )}
            </div>
          </div>
          {!mobile && <div className={`casino-book text-center w-100 ${bookCls(book)}`}>{fmtBook(book)}</div>}
        </div>
      </div>
    );
  };

  return (
    <>
      {/* ── Desktop ── */}
      <div className="d-none-small">
        <div className="casino-box">
          <div className="teen1daycasino-container">
            <div className="teen1dayleft">
              <h4 className="playera">Hands</h4>
              <div className="casino-row-container">
                {PLAYERS.map((p) => handsBox(p, false))}
              </div>
            </div>
            <div className="teen1daycenter"></div>
            <div className="teen1dayright pattern">
              <h4>Pattern</h4>
              <div className="casino-row-container">
                {PATTERNS.map((pt) => patternBox(pt, false))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Mobile ── */}
      <div className="d-none-big">
        <div className="casino-tabs">
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <a
                href="#hands"
                data-toggle="tab"
                className={`nav-link${activeTab === 'hands' ? ' active' : ''}`}
                onClick={(e) => { e.preventDefault(); setActiveTab('hands'); }}
              >
                Hands
              </a>
            </li>
            <li className="nav-item">
              <a
                href="#pattern"
                data-toggle="tab"
                className={`nav-link${activeTab === 'pattern' ? ' active' : ''}`}
                onClick={(e) => { e.preventDefault(); setActiveTab('pattern'); }}
              >
                Pattern
              </a>
            </li>
          </ul>
        </div>
        <div className="casino-box mb-2 tab-content">
          <div id="hands" className={`tab-pane hands${activeTab === 'hands' ? ' active' : ''}`}>
            <div className="casino-row-container">
              {PLAYERS.map((p) => handsBox(p, true))}
            </div>
          </div>
          <div id="pattern" className={`tab-pane fade pattern${activeTab === 'pattern' ? ' active show' : ''}`}>
            <div className="casino-row-container">
              {PATTERNS.map((pt) => patternBox(pt, true))}
            </div>
          </div>
        </div>
      </div>

      {/* Remark marquee */}
      <div className="casino-remark mt-3">
        <div className="remark-icon"><img src={REMARK_ICON} /></div>
        {' '}
        <marquee>{remark}</marquee>
      </div>
    </>
  );
});

export default BetTablePoker6;
